import type { ReactNode } from "react";
import { allDocPages } from "../content";
import DocsLayout from "../layout";
import { CoverageTable, Legend } from "./components";

const markets = [
  "Cboe Futures Exchange", "CFFEX", "cmdty Cash Grain Prices", "cmdty Grain Indexes",
  "cmdty Refined Fuels", "cmdty Scrap Metal Indexes", "cmdtyStats", "CME Group - CBOT",
  "CME Group - CME", "CME Group - Comex", "CME Group - Nymex", "Dalian Commodity Exchange",
  "DGCX - Dubai", "EEX Commodities", "Eurex", "Euronext Commodities (MATIF)",
  "Euronext Index Futures", "Hong Kong Futures Exchange", "ICE Canada", "ICE Europe",
  "ICE Liffe", "ICE US", "Kansas City Board of Trade", "London Metal Exchange",
  "MATBA", "MEFF Derivatives", "Minneapolis Grain Exchange", "NASDAQ OMX Nordic",
  "NCDEX", "NZX Derivatives", "ROFEX", "Shanghai - INE", "Shanghai Futures Exchange",
  "TAIFEX", "Thailand Futures Exchange", "TMX Futures", "TOCOM", "Zhengzhou Commodity Exchange",
];

const rows = markets.map(market => ({
  market,
  historical: "A",
  delayed: "A",
  realTime: "A",
  level2: "N",
}));

export default function CommoditiesPage(): ReactNode {
  const page = allDocPages.find(p => p.slug === "data-coverage-commodities")!;
  return (
    <DocsLayout page={page}>
      <Legend/>
      <CoverageTable rows={rows}/>
    </DocsLayout>
  );
}
